<template>
  <div>
    <div class="list-group list-group-flush">
      <div
        class="list-group-item d-flex mb-1 align-items-center"
        v-for="sid in selectedItems"
        :key="sid.olab_id"
      >
        <div v-if="user.email == sid.creator" class="col-1 m-auto">
          <button
            :style="{ display: sid.editDisplayState }"
            type="button"
            class="btn btn-info"
            data-toggle="modal"
            data-target="#selectEditItem"
            v-on:click="registerItem(sid)"
            data-backdrop="static"
            data-keyboard="false"
          >
            <font-awesome-icon icon="edit" />
          </button>
        </div>
        <div v-else class="col-1 m-auto">
          <!-- NOP -->
        </div>

        <div v-if="selectedItem != null" class="modal fade" id="selectEditItem">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  OLAB ID:
                  <span class="text-dark">{{ selectedItem.olab_id }}</span>
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <!-- .modal-header -->
              <div class="modal-body">
                <form>
                  <fieldset class="form-group">
                    <!-- <legend>{{selectedType}} Info</legend> -->
                    <div class="form-group">
                      <label class="form-control-label font-italic">
                        <span>Name:</span>
                        <span v-if="item.name == ''" class="small text-danger"
                          >*</span
                        >
                      </label>
                      <input
                        class="form-control"
                        v-bind:class="item.getValidState(item.name)"
                        type="text"
                        v-model="item.name"
                      />
                      <!-- <div class="invalid-feedback">{{invalidFB.name}}</div> -->
                    </div>

                    <div
                      v-if="
                        selectedType === 'library_sequence' && dbInfo.db_configs
                      "
                      class="form-group"
                    >
                      <label class="form-control-label font-italic">
                        <span>Sequence Origin:</span>
                        <span
                          v-if="item.seq_origin == ''"
                          class="small text-danger"
                          >*</span
                        >
                      </label>
                      <select
                        class="form-control"
                        v-bind:class="item.getValidState(item.seq_origin)"
                        v-model="item.seq_origin"
                      >
                        <option disabled value="null">Please select one</option>
                        <option
                          v-for="seq in dbInfo.db_configs.seq_origins"
                          :key="seq.olab_id"
                          >{{ seq.strain }} &nbsp; - &nbsp;
                          {{ seq.name }}</option
                        >
                      </select>
                      <!-- <div class="invalid-feedback">{{ invalidFB.seq_origin }}</div> -->
                      <!-- <span>selected = {{item.seq_origin}}</span> -->
                    </div>

                    <div v-if="selectedType === 'project'" class="form-group">
                      <label class="form-control-label font-italic">
                        <span>Start Date:</span>
                        <span
                          v-if="item.start_date == ''"
                          class="small text-danger"
                          >*</span
                        >
                      </label>
                      <input
                        class="form-control"
                        v-bind:class="item.getValidState(item.start_date)"
                        type="date"
                        v-model="item.start_date"
                      />
                      <!-- <div class="invalid-feedback">{{invalidFB.startDate}}</div> -->
                    </div>
                    <div v-if="selectedType === 'project'" class="form-group">
                      <label class="form-control-label font-italic"
                        >End Date:</label
                      >
                      <input
                        class="form-control"
                        type="date"
                        v-model="item.end_date"
                      />
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic"
                        >Project ID:</label
                      >
                      <select class="form-control" v-model="item.project_id">
                        <option disabled value="null">Please select one</option>
                        <option v-for="pj in projects" :key="pj.olab_id">{{
                          pj.olab_id
                        }}</option>
                      </select>
                      <!-- <span>selected = {{item.project_id}}</span> -->
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic">
                        <span>Parent ID:</span>
                        <span
                          v-if="item.parent_id == ''"
                          class="small text-danger"
                          >*</span
                        >
                      </label>
                      <select
                        class="form-control"
                        v-bind:class="item.getValidState(item.parent_id)"
                        v-model="item.parent_id"
                      >
                        <option disabled value="null">Please select one</option>
                        <option v-for="sss in strains" :key="sss.olab_id">{{
                          sss.olab_id
                        }}</option>
                      </select>
                      <!-- <div class="invalid-feedback">{{invalidFB.parentID}}</div> -->
                      <!-- <span>selected = {{item.parent_id}}</span> -->
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic"
                        >Mutations:</label
                      >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.mutations"
                      />
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic">
                        <span>Antibiotic Resistance:</span>
                        <span
                          v-if="item.antibiotic_resistance == ''"
                          class="small text-danger"
                          >*</span
                        >
                      </label>
                      <input
                        class="form-control"
                        v-bind:class="
                          item.getValidState(item.antibiotic_resistance)
                        "
                        type="text"
                        v-model="item.antibiotic_resistance"
                      />
                      <!-- <div class="invalid-feedback">{{invalidFB.antibioticResistance}}</div> -->
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic"
                        >WGS Confirmed:</label
                      >
                      <div class="form-check form-check-inline mx-1">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="true"
                          v-model="item.wgs_confirmed"
                        />
                        <label class="form-check-label">true</label>
                      </div>
                      <div class="form-check form-check-inline mx-1">
                        <input
                          class="form-check-input"
                          type="radio"
                          value="false"
                          v-model="item.wgs_confirmed"
                        />
                        <label class="form-check-label">false</label>
                      </div>
                    </div>
                    <div
                      v-if="selectedType === 'library_sequence'"
                      class="form-group"
                    >
                      <label class="form-control-label font-italic"
                        >Library:</label
                      >
                      <!-- <select class="form-control" v-model="item.library_id">
                        <option disabled value="null">Please select one</option>
                        <option v-for="lll in libraries" :key="lll.olab_id">{{lll.olab_id}}</option>
                      </select>-->
                      <span class="ml-1">{{ printLibraryInfo }}</span>
                    </div>
                    <div
                      v-if="
                        selectedType === 'strain' ||
                          selectedType === 'library_sequence'
                      "
                      class="form-group"
                    >
                      <label class="form-control-label font-italic"
                        >Source:</label
                      >
                      <select class="form-control" v-model="item.source">
                        <option disabled value="null">Please select one</option>
                        <option value="inhouse">inhouse</option>
                        <option value="public">public</option>
                      </select>
                      <!-- <span>selected = {{item.source}}</span> -->
                    </div>
                    <div v-if="selectedType === 'strain'" class="form-group">
                      <label class="form-control-label font-italic">
                        <span>Storage:</span>
                        <span
                          v-if="item.storage == ''"
                          class="small text-danger"
                          >*</span
                        >
                      </label>
                      <input
                        class="form-control"
                        v-bind:class="item.getValidState(item.storage)"
                        type="text"
                        v-model="item.storage"
                      />
                      <!-- <div class="invalid-feedback">{{invalidFB.storage}}</div> -->
                    </div>
                    <div v-if="selectedType === 'cart'">
                      <label class="form-control-label font-italic"
                        >Project ID:</label
                      >
                      <span class="ml-1">{{ printProjectInfo }}</span>
                    </div>
                    <div class="text-wrap">
                      <label class="form-control-label font-italic"
                        >Creator:</label
                      >
                      <span class="ml-1">{{ item.creator }}</span>
                    </div>
                    <div
                      v-if="selectedType === 'package'"
                      class="py-1 text-wrap"
                    >
                      <span class="font-italic mr-1">Package Type:</span>
                      <span class="h5 text-dark"
                        >{{ selectedItem.package_type }} -
                        {{ selectedItem.package_seq_type }}</span
                      >
                    </div>
                    <div class="py-1 form-group">
                      <label class="form-control-label font-italic"
                        >Description:</label
                      >
                      <textarea
                        class="form-control"
                        v-model="item.desc"
                      ></textarea>
                    </div>
                    <div
                      v-if="selectedType === 'library_sequence'"
                      class="card"
                    >
                      <div class="card-header text-dark">Sequence</div>
                      <div v-if="selectedItem.seq" class="card-body">
                        <div
                          class="py-1 small text-monospace text-dark text-wrap"
                        >
                          {{ selectedItem.seq }}
                        </div>
                        <div v-if="selectedItem.seq" class="py-1">
                          <span class="font-italic small mr-1">Length:</span>
                          <span class="h5 small text-dark">{{
                            selectedItem.seq.length
                          }}</span>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                    <div
                      v-if="
                        (selectedType === 'cart' ||
                          selectedType === 'package') &&
                          selectedItem.comps
                      "
                      class="card"
                    >
                      <div class="card-header text-dark">Components</div>
                      <div class="card-body">
                        <div class="list-group">
                          <div
                            class="list-group-item text-wrap"
                            v-for="comp in selectedItem.comps"
                            :key="comp.index"
                          >
                            <div>
                              <span class="mr-1 small text-secondary"
                                >OLAB ID:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.olab_id
                              }}</span>
                              <span
                                v-if="comp.name"
                                class="mr-1 small text-secondary"
                                >Name:</span
                              >
                              <span
                                v-if="comp.name"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.name }}</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-1 small text-secondary"
                                >Locus Tag:</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.locus_tag }}</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-1 small text-secondary"
                                >Old Locus Tag:</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.old_locus_tag }}</span
                              >
                              <span class="mr-1 small text-secondary"
                                >Use As:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.use_seq_as
                              }}</span>
                              <span
                                v-if="comp.length"
                                class="mr-1 small text-secondary"
                                >Length:</span
                              >
                              <span
                                v-if="comp.length"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.length }}</span
                              >
                              <span class="mr-1 small text-secondary"
                                >Quantity:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.qty
                              }}</span>
                            </div>
                            <div v-if="selectedType === 'package'" class="mt-1">
                              <span class="mr-1 small text-secondary"
                                >Sequence:</span
                              >
                              <span
                                class="mr-3 small text-monospace text-dark"
                                >{{ comp.seq }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </fieldset>
                  <!-- .form-group -->
                </form>
              </div>
              <!-- .modal-body -->
              <div class="modal-footer">
                <button
                  type="button"
                  v-bind:disabled="itemSaveIsDisabled == true"
                  class="btn btn-primary"
                  data-dismiss="modal"
                  v-on:click="handleSaveItem(item)"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
              <!-- .modal-footer -->
            </div>
            <!-- .modal-content -->
          </div>
          <!-- .modal-dialog .modal-lg-->
        </div>
        <!-- .modal fade #selectEditItem -->

        <div v-if="selectedType === 'project'" class="col-3 mx-2">
          <OlabProjectSVGGen name="Project" textPosX="160" textPosY="280" />
        </div>

        <div v-if="selectedType === 'cart'" class="col-3 mx-2">
          <OlabCartSVGGen :comps="sid.comps" />
        </div>

        <div v-if="selectedType === 'package'" class="col-3 mx-2">
          <OlabPackageSVGGen
            :type="sid.package_type"
            :seqType="sid.package_seq_type"
            :comps="sid.comps"
          />
        </div>

        <div class="col-3 mx-2" v-if="selectedType === 'strain'">
          <OlabStrainSVGGen name="Strain" textPosX="160" textPosY="280" />
        </div>

        <div v-if="selectedType === 'library_sequence'" class="col-3 mx-2">
          <OlabSampleSVGGen name="Sequence" textPosX="230" textPosY="390" />
        </div>

        <div class="col text-truncate">
          <a
            class="h3 text-info"
            data-toggle="modal"
            href="#itemDetailInfo"
            v-on:click="registerItem(sid)"
            data-backdrop="static"
            data-keyboard="false"
            >{{ sid.olab_id }}</a
          >

          <div
            v-if="selectedItem != null"
            class="modal fade"
            id="itemDetailInfo"
          >
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    OLAB ID:
                    <span class="h5 text-dark">{{ selectedItem.olab_id }}</span>
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <!-- .modal-header -->
                <div class="modal-body">
                  <div class="text-wrap">
                    <span class="font-italic mr-1">Name:</span>
                    <span class="h5 text-dark">{{ selectedItem.name }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Sequence Origin:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.seq_origin
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'cart'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Project:</span>
                    <span class="h5 text-dark">{{ printProjectInfo }}</span>
                  </div>
                  <div v-if="selectedType === 'project'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Start Date:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.start_date
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'project'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">End Date:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.end_date
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Type:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.microbe_type
                    }}</span>
                    <span class="font-italic mr-1 ml-5">WGS Confirmed:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.wgs_confirmed
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Project:</span>
                    <span class="h5 text-dark">{{ printProjectInfo }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Parent:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.parent_id
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Source:</span>
                    <span class="h5 text-dark">{{ selectedItem.source }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Mutations:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.mutations
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Antibiotic Resistance:</span>
                    <span class="h5 text-dark">{{
                      selectedItem.antibiotic_resistance
                    }}</span>
                  </div>
                  <div v-if="selectedType === 'strain'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Storage:</span>
                    <span class="h5 text-dark">{{ selectedItem.storage }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Source:</span>
                    <span class="h5 text-dark">{{ selectedItem.source }}</span>
                  </div>
                  <div class="py-1 text-wrap">
                    <span class="font-italic mr-1">Creator:</span>
                    <span class="h5 text-dark">{{ selectedItem.creator }}</span>
                  </div>
                  <div
                    v-if="selectedType === 'library_sequence'"
                    class="py-1 text-wrap"
                  >
                    <span class="font-italic mr-1">Library ID:</span>
                    <span class="h5 text-dark">{{ printLibraryInfo }}</span>
                  </div>
                  <div v-if="selectedType === 'package'" class="py-1 text-wrap">
                    <span class="font-italic mr-1">Package Type:</span>
                    <span class="h5 text-dark"
                      >{{ selectedItem.package_type }} -
                      {{ selectedItem.package_seq_type }}</span
                    >
                  </div>
                  <div v-if="selectedType === 'library_sequence'" class="py-1">
                    <div class="card">
                      <div class="card-header text-dark">Sequence</div>
                      <div v-if="selectedItem.seq" class="card-body">
                        <div
                          class="py-1 small text-monospace mr-1 text-dark text-wrap"
                        >
                          {{ selectedItem.seq }}
                        </div>
                        <div v-if="selectedItem.seq" class="py-1">
                          <span class="font-italic small mr-1">Length:</span>
                          <span class="h5 small text-dark">{{
                            selectedItem.seq.length
                          }}</span>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                  <div class="py-1">
                    <div class="card">
                      <div class="card-header text-dark">Description</div>
                      <div class="card-body">
                        <div class="py-1 small font-italic text-dark text-wrap">
                          {{ selectedItem.desc }}
                        </div>
                      </div>
                      <div
                        v-if="selectedItem.desc_hyperlink"
                        class="card-footer text-center"
                      >
                        <span class="px-3 font-italic">Go to:</span>
                        <a
                          :href="selectedItem.desc_hyperlink"
                          target="_blank"
                          class="card-link"
                          >NCBI
                        </a>
                      </div>
                      <div
                        v-if="selectedItem.download_file"
                        class="card-footer text-center"
                      >
                        <span class="px-3 font-italic">Download:</span>
                        <a
                          :href="selectedItem.download_file"
                          target="_blank"
                          class="card-link"
                          download
                          >{{ selectedItem.download_file }}
                        </a>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                  <div
                    v-if="
                      (selectedType === 'cart' || selectedType === 'package') &&
                        selectedItem.comps
                    "
                    class="py-1"
                  >
                    <div class="card">
                      <div class="card-header text-dark">Components</div>
                      <div class="card-body">
                        <div class="list-group">
                          <div
                            class="list-group-item text-wrap"
                            v-for="comp in selectedItem.comps"
                            :key="comp.index"
                          >
                            <div>
                              <span class="mr-1 small text-secondary"
                                >OLAB ID:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.olab_id
                              }}</span>
                              <span
                                v-if="comp.name"
                                class="mr-1 small text-secondary"
                                >Name:</span
                              >
                              <span
                                v-if="comp.name"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.name }}</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-1 small text-secondary"
                                >Locus Tag:</span
                              >
                              <span
                                v-if="comp.locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.locus_tag }}</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-1 small text-secondary"
                                >Old Locus Tag:</span
                              >
                              <span
                                v-if="comp.old_locus_tag"
                                class="mr-3 font-italic text-dark"
                                >{{ comp.old_locus_tag }}</span
                              >
                              <span class="mr-1 small text-secondary"
                                >Use As:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.use_seq_as
                              }}</span>
                              <span class="mr-1 small text-secondary"
                                >Length:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.length
                              }}</span>
                              <span class="mr-1 small text-secondary"
                                >Quantity:</span
                              >
                              <span class="mr-3 font-italic text-dark">{{
                                comp.qty
                              }}</span>
                            </div>
                            <div v-if="selectedType === 'package'" class="mt-1">
                              <span class="mr-1 small text-secondary"
                                >Sequence:</span
                              >
                              <span
                                class="mr-3 small text-monospace text-dark"
                                >{{ comp.seq }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- .card-body -->
                    </div>
                    <!-- .card -->
                  </div>
                </div>
                <!-- .modal-body -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
                <!-- .modal-footer -->
              </div>
              <!-- .modal-content -->
            </div>
            <!-- .modal-dialog .modal-lg-->
          </div>
          <!-- .modal fade #itemDetailInfo -->

          <div class="h5 mt-2">{{ sid.name }}</div>
          <div v-if="selectedType === 'library_sequence'" class="h5">
            {{ sid.seq_origin }}
          </div>
          <div class="h5">
            {{ sid.creator }}
          </div>
          <div
            v-if="selectedType === 'library_sequence'"
            class="mb-0 text-monospace text-truncate"
          >
            {{ sid.seq }}
          </div>
          <div v-if="selectedType === 'library_sequence' && sid.seq" class="h5">
            {{ sid.seq.length }}
          </div>
          <div v-if="selectedType === 'strain' && sid.show_genes" class="h5">
            <button
              type="button"
              v-on:click="handleSwitchToGene(sid)"
              class="btn btn-info"
            >
              View Genes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import OlabCartSVGGen from "@/components/OlabCartSVGGen";
import OlabPackageSVGGen from "@/components/OlabPackageSVGGen";
import OlabProjectSVGGen from "@/components/OlabProjectSVGGen";
import OlabSampleSVGGen from "@/components/OlabSampleSVGGen";
import OlabStrainSVGGen from "@/components/OlabStrainSVGGen";
import { OlabItem } from "../olab/olabitem.js";
import { OlabUtils } from "../olab/olabutils.js";

export default {
  name: "databaseitemlist",
  data: function() {
    return {
      selectedItem: null,
      invalidFB: OlabItem.getInvalidFeedbacks()
    };
  },
  props: [
    "user",
    "dbInfo",
    "projects",
    "microbes",
    "strains",
    "libraries",
    "error",
    "selectedItems",
    "selectedType",
    "item"
  ],
  components: {
    FontAwesomeIcon,
    OlabCartSVGGen,
    OlabPackageSVGGen,
    OlabProjectSVGGen,
    OlabSampleSVGGen,
    OlabStrainSVGGen
  },
  computed: {
    printProjectInfo: function() {
      if (this.projects != null) {
        for (let i = 0; i < this.projects.length; i++) {
          if (this.projects[i].olab_id == this.selectedItem.project_id) {
            return this.projects[i].olab_id + " - " + this.projects[i].name;
          }
        }
      }
      return "";
    },
    printLibraryInfo: function() {
      if (this.libraries != null) {
        for (let i = 0; i < this.libraries.length; i++) {
          if (this.libraries[i].olab_id == this.selectedItem.library_id) {
            return this.libraries[i].olab_id + " - " + this.libraries[i].name;
          }
        }
      }
      return "";
    },
    itemSaveIsDisabled: function() {
      switch (this.selectedType) {
        case "project":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.start_date)
          );
        // break;
        case "cart":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.creator) ||
            !this.item.isValid(this.item.project_id)
          );
        // break;
        case "strain":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.parent_id) ||
            !this.item.isValid(this.item.antibiotic_resistance) ||
            !this.item.isValid(this.item.storage) ||
            !this.item.isValid(this.item.creator)
          );
        // break;
        case "library_sequence":
          return (
            !this.item.isValid(this.item.name) ||
            !this.item.isValid(this.item.seq_origin) ||
            !this.item.isValid(this.item.creator)
          );
        // break;
      }
      return false;
    }
  },
  methods: {
    registerItem: function(item) {
      this.selectedItem = item;
      // OlabUtils.infoLog("registerItem: item = " + item);
      // Copy data to this.item so that v-model for edit item.
      this.item.set(item);
    },
    handleSaveItem: function(item) {
      OlabUtils.infoLog("handleSaveItem: selectedType = " + this.selectedType);
      // OlabItem.infoLog(item);

      // Add additional field before emit
      item.olab_type = this.selectedType;
      this.$emit("doSaveItem", {
        item: item,
        items: this.selectedItems
      });

      // Update selectedItem
      this.registerItem(item);
    },
    handleSwitchToGene: function(item) {
      OlabUtils.infoLog(
        "handleSwitchToGene: selectedType = " + this.selectedType
      );
      // OlabItem.infoLog(item);
      this.$emit("doSwitchToGene", item);
    }
  }
};
</script>
